import {
  InboundMessageListItem,
  PickupReviewStatus,
} from "../../../../app/data/communications/models";

export const REVIEW_STATUS_DISPLAY_ORDER: PickupReviewStatus[] = [
  "REQUIRE_HUMAN_REVIEW",
  "APPROVED_BY_SYSTEM",
  "APPROVED_BY_HUMAN",
  "REJECTED_BY_HUMAN",
  "REJECTED_BY_SYSTEM",
];

export interface InboxReviewStatusCount {
  status: PickupReviewStatus;
  count: number;
}

export const aggregateInboxReviewStatusCounts = (
  row: InboundMessageListItem
): InboxReviewStatusCount[] => {
  const counts = new Map<PickupReviewStatus, number>();

  for (const serviceRequest of row.serviceRequests ?? []) {
    const status = serviceRequest.pickupRequest?.reviewStatus;
    if (!status) continue;
    counts.set(status, (counts.get(status) ?? 0) + 1);
  }

  return REVIEW_STATUS_DISPLAY_ORDER.filter((status) => (counts.get(status) ?? 0) > 0).map(
    (status) => ({
      status,
      count: counts.get(status)!,
    })
  );
};
